import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import QuickQuoteForm from './components/QuickQuoteForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QuickQuoteForm />
  </React.StrictMode>
); 